import { render, staticRenderFns } from "./StudentProgress.vue?vue&type=template&id=0fc47188&"
import script from "./StudentProgress.vue?vue&type=script&lang=js&"
export * from "./StudentProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports